import gql from 'graphql-tag';

/**
 * Query to fetch a single inspection instance by ID with full detail
 * including responses, observations, lastPosition, and the template snapshot.
 */
export const getInspectionInstanceDetailQuery = gql`
  query getInspectionInstanceDetail($id: UUID!, $channelId: UUID!) {
    inspectionInstance(id: $id, channelId: $channelId) {
      id
      schemaVersion
      version
      templateRef {
        templateId
        version
        templateName
      }
      metadata {
        buildingId {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        tenantId {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        suiteId {
          sourceEntityId
          sourceEntityType
          sourceType
        }
        assignedTo
        scheduledFor
        scheduleId
        createdAt
        createdBy
      }
      state {
        status
        startedAt
        completedAt
        completedBy
        completionNotes
        closedReason
        lastPosition {
          sectionId
          itemId
        }
        progress {
          totalItems
          completedItems
          requiredItems
          completedRequiredItems
          sectionProgress {
            sectionId
            total
            completed
          }
        }
      }
      responses {
        itemId
        value
        notes
        additionalFields
        isDeficient
        serviceRequestIds
        photos {
          id
          localPath
          remoteUrl
          thumbnailUrl
          uploadStatus
          metadata {
            capturedAt
            fileSize
            contentType
            caption
            location {
              latitude
              longitude
              accuracy
            }
            dimensions {
              width
              height
            }
          }
        }
        timestamps {
          createdAt
          updatedAt
          deviceTimestamp
        }
        syncState {
          status
          lastAttempt
          error
          retryCount
        }
      }
      observations {
        id
        sectionId
        description
        addedAt
        suggestAddToTemplate
        response {
          itemId
          value
          notes
          additionalFields
          isDeficient
          serviceRequestIds
          photos {
            id
            localPath
            remoteUrl
            thumbnailUrl
            uploadStatus
            metadata {
              capturedAt
              fileSize
              contentType
              caption
              location {
                latitude
                longitude
                accuracy
              }
              dimensions {
                width
                height
              }
            }
          }
          timestamps {
            createdAt
            updatedAt
            deviceTimestamp
          }
          syncState {
            status
            lastAttempt
            error
            retryCount
          }
        }
      }
      template {
        id
        schemaVersion
        version
        parentTemplateId
        locked
        parentTemplateLockedVersion
        metadata {
          name
          description
          templateType
          assetTypes
          tags
          buildingId {
            sourceEntityId
            sourceEntityType
            sourceType
          }
          createdAt
          createdBy
        }
        config {
          requirePhotoOnDeficiency
          maxPhotosPerItem
          requireNoteOnDeficiency
          defaultQuestionType
          allowObservationItems
          completionRules {
            allItemsRequired
            allowPartialSubmission
          }
        }
        sections {
          id
          name
          description
          order
          config {
            requirePhotoOnDeficiency
            skippable
            collapsedByDefault
          }
          items {
            id
            label
            helpText
            order
            questionType
            questionConfig
            required
            photosEnabled
            notesEnabled
            config {
              requirePhotoOnDeficiency
              requireNoteOnDeficiency
              minPhotos
              isComplianceItem
              tags
              category
            }
          }
        }
      }
    }
  }
`;
